"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveWidget = void 0;
const command_manager_1 = require("../../command_manager");
const datasheet_1 = require("../../model/datasheet");
const selectors_1 = require("../../exports/store/selectors");
exports.moveWidget = {
    undoable: false,
    execute(context, options) {
        const { model: state } = context;
        const { layout, panelId, resourceType, resourceId } = options;
        const widgetPanels = (0, selectors_1.getResourceWidgetPanels)(state, resourceId, resourceType);
        if (!widgetPanels) {
            return null;
        }
        const activePanelIndex = widgetPanels.findIndex(item => item.id === panelId);
        if (activePanelIndex < 0) {
            return null;
        }
        const widgets = widgetPanels[activePanelIndex].widgets;
        const installedWidgetIds = widgets.map(widget => widget.id);
        const ids = layout.map(v => v.id);
        const _ids = [...new Set([...ids, ...installedWidgetIds])];
        if (_ids.length !== ids.length) {
            return null;
        }
        const moveWidgetAction = datasheet_1.DatasheetActions.moveWidget2Action(state, {
            widgetPanelIndex: activePanelIndex, layout, resourceType, resourceId
        });
        if (!moveWidgetAction) {
            return null;
        }
        return {
            result: command_manager_1.ExecuteResult.Success,
            resourceId: resourceId,
            resourceType: resourceType,
            actions: moveWidgetAction,
        };
    },
};
//# sourceMappingURL=move_widget.js.map